import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { LoadingBlock } from "@/components/AsyncState";

const TicketsPage = lazy(() => import("@/pages/TicketsPage"));

function TicketsFallback() {
  return (
    <div className="relative px-5 pt-14">
      <LoadingBlock label="Loading tickets…" />
    </div>
  );
}

function TicketsRoute() {
  return (
    <Suspense fallback={<TicketsFallback />}>
      <TicketsPage />
    </Suspense>
  );
}

export const Route = createFileRoute("/tickets")({
  head: () => ({
    meta: [
      { title: "My Tickets · Pulse" },
      {
        name: "description",
        content: "Your purchased Pulse tickets with QR codes — ready to scan or share.",
      },
    ],
  }),
  component: TicketsRoute,
});
